let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("haS2H")).then(() => parcelRequire('deqLp'));